import { useEffect } from "react";
import { FormikProvider, useFormik } from "formik";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";
import RadioButton from "../RadioButton";
import { ReportReasons } from "@const/report";
import { initialValues } from "./form";

import styles from "./index.module.scss";
import { removeEmptyKeys } from "@helpers/common";

const formId = "reportUserForm";

const ReportModal = ({
  action,
  id,
  isOpen,
  toggle,
  footerClassName,
  additionalFields,
  initialValues: propsValues,
}) => {
  const { t } = useTranslation("buttons");
  const { t: t1 } = useTranslation("modals");
  const { t: t2 } = useTranslation("common");
  const { t: t3 } = useTranslation("reports");
  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    dispatch(action({ id, report: removeEmptyKeys({ ...values }) }));
    toggle();
  };

  const formik = useFormik({
    onSubmit: handleSubmit,
    initialValues: propsValues ?? initialValues,
  });

  const { values, resetForm } = formik;

  useEffect(() => {
    resetForm();
  }, [isOpen, resetForm]);

  return (
    <Modal
      centered
      title={t2("REPORT")}
      onCancel={toggle}
      onClose={toggle}
      submitDisabled={!values.type}
      cancelText={t("CANCEL")}
      confirmText={t("SEND")}
      confirmType="submit"
      confirmForm={formId}
      isOpen={isOpen}
      unmountOnClose
      footerClassName={classNames(footerClassName, styles.modalFooter)}
      cancelClassName={classNames(styles.modalButton, "mb-2 mb-xl-0")}
      bodyClassName={styles.body}
      confirmClassName={styles.modalButton}
    >
      <FormikProvider value={formik}>
        <form id={formId} onSubmit={formik.handleSubmit}>
          <div className="mb-3 text-subtitle-2 text-tertiary">
            {t1("REPORT_CREATOR_BODY")}
          </div>
          {ReportReasons.map(({ label, value }) => (
            <RadioButton
              value={value.toString()}
              key={value}
              name="type"
              label={t3(label)}
              wrapperClassName={styles.radioButtonWrapper}
            />
          ))}
          {additionalFields}
        </form>
      </FormikProvider>
    </Modal>
  );
};

export default ReportModal;
